import Store from "@/store/";
import Header from "@/components/layout/header";
import Footer from "@/components/layout/footer";

const COMMON_LAYOUT = (Content) => {
  return { top: Header, Content, bottom: Footer };
};

const ETC_LAYOUT = (Content) => {
  return { Content };
};

// 비밀번호 재설정
const userPasswordReset = (query) => {
  window.routeQuery = query;
  return query.via && query.via === "repd";
};

// 로그인 후 접근하면 안되는 페이지
const loginAfterStopPage = (pageName) => {
  const stopPage = ["Login", "Member"];
  const isStopPage = stopPage.find((page) => page === pageName) ? true : false;
  return Store.getters.isLogin && isStopPage;
};

// 로그인 전 접근하면 안되는 페이지
const loginBeforeStopPage = (isLogin) => {
  return isLogin && !Store.getters.isLogin;
};
const userCertificationModal = (query) => {
  const vueSelect = window.vueElement;
  const params = query.u ?? "";

  if (params === "") return false;

  if (params === "10002") {
    vueSelect
      .$alert(
        vueSelect.$t("confirmEmail.content"),
        vueSelect.$t("confirmEmail.title"),
        {
          dangerouslyUseHTMLString: true,
        }
      )
      .then(async () => {
        await vueSelect.$gtm.trackEvent({
          event: "ga_register",
        });
      });
  }

  // if (params === "20002") {
  // }

  return true;
};

const Controller = async (to, from, next) => {
  await Store.dispatch("updateUserInfo");

  // 비밀번호 재설정
  if (to.query.via) {
    userPasswordReset(to.query) ? next({ path: "/pw/confirm" }) : "";
  }
  // 이메일인증 / OTP초기화 모달
  userCertificationModal(to.query) ? next({ path: "/login" }) : "";

  // 로그인 후 접근하면 안되는 페이지
  loginAfterStopPage(to.name) ? next({ path: "/" }) : "";

  // 로그인 전 접근하면 안되는 페이지
  loginBeforeStopPage(to.meta.isLogin) ? next({ path: "/login" }) : "";

  return next();
};

export { COMMON_LAYOUT, ETC_LAYOUT, Controller };
